module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/golfCartFeatured1.webp";